import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Iter 26.12 — register service worker for PWA installability + share-target
// intercept. Only in production (CRA dev server doesn't serve a stable SW).
// On Android Chrome this is what makes "Spy Finance" appear in OS share
// sheets and what makes "Add to Home screen" promote a real app icon.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .catch(() => { /* silent — site still works without it */ });
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
